import axios from "axios";
const SPESAILITE_API_BASE_URL =
  "https://doclicapp.herokuapp.com/api/admin/speciality";
const ADDADMIN_API_BASE_URL = "https://doclicapp.herokuapp.com/api/admin/add";
//
const GETPROFIL_API_BASE_URL =
  "https://doclicapp.herokuapp.com/api/admin/healthPro";
const GETPROFILdetails_API_BASE_URL =
  "https://doclicapp.herokuapp.com/api/admin";
// const POSTPROFIL_API_BASE_URL =
//   "https://doclicapp.herokuapp.com/api/healthPro/details/add";
const UPDAITEPROFIL_API_BASE_URL =
  //de
  "https://doclicapp.herokuapp.com/api/admin/details/add";
//
const GETCABINET_API_BASE_URL =
  "https://doclicapp.herokuapp.com/api/healthPro/info";
const POSTCABINET_API_BASE_URL =
  "https://doclicapp.herokuapp.com/api/healthPro/add";

const UPDAITECABINET_API_BASE_URL =
  "https://doclicapp.herokuapp.com/api/healthPro/update";

const GETPROSONTER3_API_BASE_URL =
  "https://doclicapp.herokuapp.com/api/admin/three";
class ServiceAdmin {
  getProSante() {
    return axios.get(GETPROSONTER3_API_BASE_URL);
  }
  getSpecailite() {
    return axios.get(SPESAILITE_API_BASE_URL);
  }
  addadmin(
    email,
    password,
    cin,
    firstName,
    lastName,
    tel,
    adresse,
    speciality,
    city,
    secteur
  ) {
    return axios.post(ADDADMIN_API_BASE_URL, {
      email,
      password,
      cin,
      firstName,
      lastName,
      tel,
      adresse,
      speciality,
      city,
      secteur,
    });
  }

  // Profile
  getprofile(id) {
    return axios.get(GETPROFIL_API_BASE_URL + "/" + id);
  }

  getprofiledetails(id) {
    return axios.get(GETPROFILdetails_API_BASE_URL + "/" + id);
  }
  // addprofil(details) {
  //   return axios.post(POSTPROFIL_API_BASE_URL, details);
  // }

  updateprofil(id, details) {
    return axios.put(UPDAITEPROFIL_API_BASE_URL, { id, details });
  }

  // Cabinet
  getcabinet(id) {
    return axios.get(GETCABINET_API_BASE_URL + "/" + id);
  }

  addcabinet(
    denomination,
    address,
    tel,
    patent,
    numRC,
    rib,
    ice,
    banque,
    formeJuridique,
    user
  ) {
    return axios.post(POSTCABINET_API_BASE_URL, {
      denomination,
      address,
      tel,
      patent,
      numRC,
      rib,
      ice,
      banque,
      formeJuridique,
      user,
    });
  }
  updatecabinet(
    id,
    denomination,
    address,
    tel,
    patent,
    numRC,
    rib,
    ice,
    banque,
    formeJuridique
  ) {
    return axios.put(UPDAITECABINET_API_BASE_URL, {
      id,
      denomination,
      address,
      tel,
      patent,
      numRC,
      rib,
      ice,
      banque,
      formeJuridique,
    });
  }
}

export default new ServiceAdmin();
